<template>
    <div class="header-icons">
        <div v-if="!isAuthenticated" class="nav-items login-menu">
            <a href="/accounts/create-or-signin" title="Register a New Account" aria-label="Register">Register</a>
            <a href="/accounts/create-or-signin" title="Log into your existing account" aria-label="Sign In">Sign In</a>
        </div>

        <div v-if="isCsr" class="admin-input" :selected="adminSearchSelected">
            <input name="admin-search" v-model="adminSearchString" type="text" class="td-input admin-search" placeholder="Admin Search" @keyup.enter="adminSearchInputKeyUp" @focus="adminSearchFocusInput" @blur="adminSearchBlurInput" />
            <icon @click.prevent="toggleControlPanel" class="input-icon" type="solid" name="faSearch" title="Search"></icon>
        </div>

        <div v-if="isCsr" :class="{ 'admin-link': true, 'conversations': true, 'none': conversationCount <= 0}">
            <a href="/systems/conversations" :title="conversationTitle">
                <icon :class="{ 'unread': unreadConversations > 0, 'nav-icon': true }" type="regular" name="faComment" aria-hidden="true" focusable="false" title="Messages"></icon>
                <span v-if="conversationCount > 0" class="td-circle-badge">{{ conversationCount }}</span>
            </a>
        </div>

        <div v-if="isCsr" :class="{ 'admin-link': true, 'tasks': true, 'none': taskCount <= 0}">
            <a href="/task-manager" :title="taskCount + (taskCount == 1 ? ' task, ' : ' tasks, ') + unassignedTaskCount + ' unassigned'">
                <icon type="solid" name="faTasks" aria-hidden="true" focusable="false" class="nav-icon"></icon>
                <span v-if="taskCount > 0" class="td-circle-badge">{{ taskCount }}</span>
            </a>
        </div>

        <requests-link v-if="isAuthenticated" :request-status="requestStatus" :request-id="requestToOpen"></requests-link>

        <a v-if="isAuthenticated" class="account-settings" href="/admin" :title="'Account Settings of ' + firstName + ' ' + lastName">
            <img width="30" height="30" :src="profilePicture" :alt="'Profile picture of ' + firstName + ' ' + lastName" />
            <span>{{ firstName }}<br />{{ lastName }}</span>
        </a>
        <div v-click-outside="closeMenu" class="side-menu">
            <icon @click.prevent="toggleMenu" type="solid" name="faBars" aria-hidden="true" focusable="false" class="nav-icon" title="Menu"></icon>
            <span v-if="showFleetSetupWidget" class="td-circle-badge">!</span>

            <transition name="layoutdropdown">
                <header-menu-list class="header-menu-list" v-if="showMenu" @close="closeMenu" :show-fleet-setup-widget="showFleetSetupWidget" error-message="Error loading menu"></header-menu-list>
            </transition>
        </div>

        <transition name="modal">
            <modal v-if="showControlPanel" @close="closeControlPanel" hide-footer hide-close class="td-admin-search-modal static">
                <control-panel class="control-panel" v-model="adminSearchString" @close="closeControlPanel" error-message="Error loading control panel"></control-panel>
            </modal>
        </transition>
    </div>
</template>

<script>
    import script from './HeaderIcons';
    export default script;</script>

<style lang="less">
    @import "./HeaderIcons.less";
</style>